export class ErrorMessage {
    constructor(
        public cssClass?: string,
        public message?: string,
        public cssClassPosition:string = '-top-right'
    ) {
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/sara-input/error-message.ts